<template>
  <div class="setting-view common-view content-view">
    <common-header/>

    <div class="container">
      <h1 class="main-title">Starter Kits</h1>

      <starter-kit
        :onPreview="handlePreview"
        :starterKits="curStarterKits"
        :styleAssets="curStyleAssets"
        :platforms="platforms"
        :tab="tab"
        :onTab="handleTab"
        isScreen
      />
    </div>

    <app-footer/>
  </div>
</template>

<script>
import { getSession } from '../utils/session';
import { sendRequest } from '../utils/api';
import StarterKit from '../components/starterkit/StarterKit';
import AppFooter from './AppFooter';
import CommonHeader from './CommonHeader';

export default {
  components: {
    AppFooter,
    StarterKit,
    CommonHeader,
  },
  data() {
    return {
      starterKits: [],
      curStarterKits: [],
      styleAssets: [],
      curStyleAssets: [],
      platforms: [],
      tab: 0,
    };
  },
  created() {
    // get all starter-kits
    sendRequest('/starter-kit', 'get', { Authorization: getSession('jwtoken') }, {})
      .then((response) => {
        this.starterKits = response.data['starter-kits'];

        this.platforms = [{
          title: 'All',
          count: this.starterKits.length,
        }];
        for (let i = 0; i < this.starterKits.length; i++) {
          const { platform } = this.starterKits[i];
          let isIn = false;
          let j;
          for (j = 0; j < this.platforms.length; j++) {
            if (this.platforms[j].title === platform) {
              isIn = true;
              break;
            }
          }

          if (isIn) {
            this.platforms[j].count += 1;
          } else {
            this.platforms.push({
              title: platform,
              count: 1,
            });
          }
        }

        // get previews for all tab
        const promiseArray = [];
        for (let i = 0; i < this.starterKits.length; i++) {
          promiseArray.push(sendRequest(
            `/theme-assets/svg/${this.starterKits[i]['preview-asset-ids'][0]}?key=000&secret=000`,
            'get',
            {},
            {},
          ));
        }

        Promise.all(promiseArray)
          .then((assets) => {
            this.styleAssets = assets.map(asset => asset.data);
            if (!this.inline && this.$route.hash) {
              const hash = this.$route.hash.substring(1);

              for (let i = 0; i < this.platforms.length; i++) {
                if (this.platforms[i].title === hash) {
                  this.handleTab(i);
                  break;
                }
              }
            } else {
              this.handleTab(0);
            }
          })
          .catch(err => console.log(err));
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    handlePreview(index) {
      this.$router.push(`/starterkits/browse/${this.curStarterKits[index].id}`);
    },
    handleTab(next) {
      this.tab = next;
      if (!this.platforms[this.tab] || this.platforms[this.tab].title === 'All') {
        this.curStarterKits = this.starterKits;
        this.curStyleAssets = this.styleAssets;
        this.tab = 0;
        window.location.hash = this.platforms[this.tab].title;
        return;
      }
      this.curStarterKits = [];
      this.curStyleAssets = [];
      for (let i = 0; i < this.starterKits.length; i++) {
        if (this.starterKits[i].platform === this.platforms[this.tab].title) {
          this.curStarterKits.push(this.starterKits[i]);
          this.curStyleAssets.push(this.styleAssets[i]);
        }
      }
      window.location.hash = this.platforms[this.tab].title;
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    max-width: 900px;
  }

  .app-footer {
    padding: 30px 0;
  }
</style>
